import React from 'react';
import { BarChart } from '@mui/x-charts';
import { Box, Typography, Tab } from "@mui/material";

const StackedBarChartbyDynamicLegends = ({ data, height = 243, title, yAxisLabel, xAxisDataKey, valueFormatterReq, xAxisLabel }) => {
    // Get BU keys (excluding 'xAxisDataKey')
    const dataKeys = Array.isArray(data) && data.length > 0 ? Object.keys(data[0]).filter(key => key !== "" && key !== xAxisDataKey) : [];
    // color palette
    const palette = [
        '#3A238C',
        '#543EA3',
        '#6754AD',
        '#7B6AB8',
        '#9384C7',
        '#A296CC',
        '#B9AFDB',
        '#D1CAEB',
        '#E2DCF2',
        '#F0EDFA'
    ];

    //Map datakeys to colors
    const buColors = {};
    dataKeys?.forEach((legendKey, idx) => {
        buColors[legendKey] = palette[idx % palette.length];
    });

    //Prepare series and data
    const series = dataKeys?.map((legendKey, idx) => ({
        dataKey: legendKey,
        label: legendKey.replace(/_/g, " ").charAt(0).toUpperCase()+legendKey.replace(/_/g, " ").slice(1),
        stack: 'total',
        color: buColors[legendKey],
    }));

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        // Format as '5 Jun'
        return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
    };

    return (
        <Box sx={{ width: "100%", boxSizing: "border-box", padding: "24px", border: '1px solid #E5E5E5', borderRadius: '8px', background: '#fff' }}>
            <Typography variant="h6" component="h4" sx={{ fontSize: '20px', fontWeight: 700, color: '#111', mb: 4 }}>
                {title}
            </Typography>
            {
                data?.length > 0 ? (
                    <BarChart
                        series={series}
                        xAxis={[
                            {
                                scaleType: "band",
                                dataKey: xAxisDataKey,
                                label: xAxisLabel,
                                valueFormatter: (value, context) => {
                                    if (context.location === "tick") {
                                        return ""
                                    }
                                    if (valueFormatterReq)
                                      return  formatDate(value)
                                }
                            },
                        ]}
                        yAxis={[
                            {
                                label: yAxisLabel,
                            },
                        ]}
                        dataset={data}
                        height={height}
                        sx={{
                            '& .MuiChartsAxis-root .MuiChartsAxis-line': { stroke: 'var(--grey-CCC)' },
                            '& .MuiYAxis-root .MuiYAxis-line': { stroke: 'var(--grey-CCC)' },
                            '& .MuiChartsAxis-root .MuiChartsAxis-tick': { stroke: 'var(--grey-CCC)' }
                        }}
                        slotProps={{
                            legend: {
                                sx: {
                                    width: '100%',
                                    marginLeft: "30px",
                                    height: "40px",
                                    marginBottom: '20px',
                                    flexDirection: 'column',
                                    overflowX: 'auto'
                                },
                            },
                        }}
                    />
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>No data to display</div>
                )
            }
        </Box>
    );
};

export default StackedBarChartbyDynamicLegends;